import React, { useState } from "react";
import { images } from "../../../assets/images";
import "./Header.scss";
import PrimaryButton from "../../../components/utils/PrimaryButton/PrimaryButton";
import VerticalSubMenu from "./VerticalSubMenu";
import { CompanyList, ServicesList } from "./data";
import Schedular from "../../../components/utils/Calendar/Schedular";
import CountUp from "../../../components/utils/CountUp/CountUp";
import { Link } from "react-router-dom";

export default function Header() {
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  const [isAppointmentOpen, setisAppointmentOpen] = useState(false);
  const [isLeftMenu, setIsLeftMenu] = useState(false);
  const closeAllMenu = () => {
    setIsCompanyOpen(false);
    setIsServiceOpen(false);
    setisAppointmentOpen(false);
    setIsLeftMenu(false);
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg">
        {/* <button
          className="left-menu"
          onClick={() => {
            closeAllMenu();
            setIsLeftMenu(true);
          }}
        >
          <img src={images.MenuIcon} alt=""/>
        </button> */}
        <div
          className={
            "container-fluid left-menu-container " + (isLeftMenu ? "show" : "")
          }
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <img
            src={images.close}
            alt=""
            className="closeBtn"
            onClick={() => closeAllMenu()}
          />
          <div className="row">
            <div className="col-3 text-start">
              <h2 className="mb-32">Contact us</h2>
              <a
                href="tel:+19876543210"
                className="hvr-underline-from-left"
                style={{ textDecoration: "none" }}
              >
                +1 987 654 3210
              </a>
              <p className="my-4">
                Prinsesse Maries Allé 11, st. th. 1908 Copenhagen
              </p>
              <a
                href="mailto:hello.world@gmail.com"
                className="hvr-underline-from-left"
              >
                hello.world@gmail.com
              </a>
              <div className="social-icon">
                <a href="Facebook">
                  <img src={images.facebook} alt="" />
                </a>
                <a href="Twitter">
                  <img src={images.twitter} alt="" />
                </a>
                <a href="Instagram">
                  <img src={images.instagram} alt="" />
                </a>
                <a href="LinkedIn">
                  <img src={images.linkedin} alt="" />
                </a>
              </div>
            </div>
            <div className="offset-3 col-6">
              <div className="container counter">
                <div className="row">
                  <div className="col-5">
                    <h2>
                      <CountUp endValue={120} />
                    </h2>
                    <h5>Happy Clients</h5>
                  </div>
                  <div className="col-5">
                    <h2>
                      <CountUp endValue={60} />+
                    </h2>
                    <h5>Running Projects</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5">
                    <h2>
                      <CountUp endValue={20} />+
                    </h2>
                    <h5>Country Served</h5>
                  </div>
                  <div className="col-5">
                    <h2>
                      <CountUp endValue={120} />k
                    </h2>
                    <h5>Projects Delivered</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid gap-2">
          <div className="sidebar-btn">
            <svg width="36" height="11" viewBox="0 0 36 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.411133" y="0.65918" width="34.9854" height="1.88072" fill="#fff"/>
              <rect x="0.411133" y="8.55859" width="34.9854" height="1.88072" fill="#EC1A1A"/>
            </svg>
          </div>
          <div className="logo" style={{padding: '0 35px'}}>
            <Link to="/">
              <img
                src={images.Logo}
                alt="techqilla website logo" 
                width="200px"
              />
            </Link>
          </div>
          {/* <Link className="navbar-brand" to="/" alt="">
            <img src={images.Logo} alt="" width="60%"/>
          </Link> */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  to="/"
                  className="nav-link me-4 active"
                  aria-current="page"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item dropdown">
                <a
                  className={
                    "nav-link me-4 dropdown-toggle " +
                    (isCompanyOpen ? "show" : "")
                  }
                  href="#"
                  id="comapanyMenu"
                  role="button"
                  // onClick={() => {
                  //   const isOpen = isCompanyOpen;
                  //   closeAllMenu();
                  //   setIsCompanyOpen(!isOpen);
                  // }}
                >
                  Company
                </a>
                <div
                  className={
                    "dropdown-menu container-fluid p-0 " +
                    (isCompanyOpen ? "show" : "")
                  }
                  aria-labelledby="comapanyMenu"
                >
                  <VerticalSubMenu subMenu={CompanyList} />
                </div>
              </li>
              <li className="nav-item dropdown">
                <a
                  className={
                    "nav-link me-4 dropdown-toggle " +
                    (isServiceOpen ? "show" : "")
                  }
                  href="#"
                  id="serviceMenu"
                  role="button"
                  // onClick={() => {
                  //   const isOpen = isServiceOpen;
                  //   closeAllMenu();
                  //   setIsServiceOpen(!isOpen);
                  // }}
                >
                  Services
                </a>
                <div
                  className={
                    "dropdown-menu container-fluid p-0 " +
                    (isServiceOpen ? "show" : "")
                  }
                  aria-labelledby="serviceMenu"
                >
                  <VerticalSubMenu subMenu={ServicesList} />
                </div>
              </li>
              <li className="nav-item">
                <Link className="nav-link me-4" to="portfolio">
                  Portfolio
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link me-4" to="contact">
                  Contact us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link me-4" to="career">
                  Career
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link me-4" to="blog">
                  Blog
                </Link>
              </li>
              {/* <li className="nav-item">
                <PrimaryButton
                  class="hvr-grow"
                  btnText="Setup an appointment"
                  variant="orangeOutline"
                  onClick={() => setisAppointmentOpen(!isAppointmentOpen)}
                />
                <div
                  className={
                    "dropdown-menu container-fluid p-0 navbar-schedular " +
                    (isAppointmentOpen ? "show" : "")
                  }
                  aria-labelledby="appointmentMenu"
                >
                  <Schedular
                    class={isAppointmentOpen ? "show" : ""}
                    close={() => setisAppointmentOpen(false)}
                  /> 
                </div>
              </li> */}
            </ul>
          </div>
          <div>
            <button style={{background:'transparent', border:'1px solid #fff',    fontSize: '16px',color: '#fff',padding: '20px 35px',borderRadius: '8px'}}>Set Up Appointment</button>
          </div>
        </div>
      </nav>

      <div className="iconbar">
        <ul>
          <a href="https://www.facebook.com/hellotechqilla">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <g clip-path="url(#clip0_650_192)">
                  <path
                    d="M16.3337 15.7502H19.2503L20.417 11.0835H16.3337V8.75016C16.3337 7.5485 16.3337 6.41683 18.667 6.41683H20.417V2.49683C20.0367 2.44666 18.6005 2.3335 17.0838 2.3335C13.9163 2.3335 11.667 4.26666 11.667 7.81683V11.0835H8.16699V15.7502H11.667V25.6668H16.3337V15.7502Z"
                    fill="#EC1A1A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_192">
                    <rect width="28" height="28" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </li>
          </a>
          <a href="https://www.linkedin.com/company/techqilla/">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="27"
                viewBox="0 0 28 27"
                fill="none"
              >
                <g clip-path="url(#clip0_650_195)">
                  <path
                    d="M25.4321 6.3628C24.5732 6.7427 23.6624 6.9922 22.7298 7.10305C23.7128 6.51516 24.4485 5.58994 24.7998 4.4998C23.8773 5.0488 22.866 5.43355 21.8118 5.64167C21.1038 4.88407 20.1653 4.38163 19.1422 4.21245C18.1191 4.04328 17.0688 4.21685 16.1545 4.70618C15.2403 5.19551 14.5133 5.97319 14.0866 6.91831C13.6599 7.86343 13.5574 8.92305 13.7951 9.93242C11.9243 9.83866 10.0942 9.35251 8.42354 8.50554C6.75287 7.65858 5.27899 6.46972 4.0976 5.01617C3.67942 5.73443 3.45967 6.55093 3.46085 7.38205C3.46085 9.0133 4.2911 10.4544 5.55335 11.2982C4.80636 11.2747 4.07581 11.0729 3.4226 10.7098V10.7683C3.42282 11.8547 3.79876 12.9076 4.48667 13.7485C5.17459 14.5894 6.13214 15.1665 7.19697 15.3819C6.50354 15.5698 5.77644 15.5975 5.07072 15.4629C5.37095 16.3981 5.9561 17.2159 6.74426 17.8019C7.53242 18.3879 8.48412 18.7128 9.4661 18.731C8.49014 19.4975 7.37267 20.0642 6.17759 20.3985C4.9825 20.7328 3.73324 20.8283 2.50122 20.6795C4.65188 22.0627 7.15545 22.7969 9.71247 22.7945C18.3671 22.7945 23.1 15.6249 23.1 9.40705C23.1 9.20455 23.0943 8.9998 23.0853 8.79955C24.0066 8.13373 24.8016 7.30894 25.4332 6.36392L25.4321 6.3628Z"
                    fill="#EC1A1A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_195">
                    <rect
                      width="27"
                      height="27"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </li>
          </a>
          <a href="https://twitter.com/techqilla">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
              >
                <g clip-path="url(#clip0_650_198)">
                  <path
                    d="M12 2.1665C14.717 2.1665 15.056 2.17734 16.122 2.2315C17.187 2.28567 17.912 2.46659 18.55 2.73525C19.21 3.01042 19.766 3.38309 20.322 3.98434C20.8305 4.52589 21.224 5.18097 21.475 5.904C21.722 6.59409 21.89 7.38059 21.94 8.53434C21.987 9.68917 22 10.0564 22 12.9998C22 15.9433 21.99 16.3105 21.94 17.4653C21.89 18.6191 21.722 19.4045 21.475 20.0957C21.2247 20.8191 20.8311 21.4743 20.322 22.0153C19.822 22.566 19.2173 22.9922 18.55 23.2644C17.913 23.532 17.187 23.714 16.122 23.7682C15.056 23.8191 14.717 23.8332 12 23.8332C9.283 23.8332 8.944 23.8223 7.878 23.7682C6.813 23.714 6.088 23.532 5.45 23.2644C4.78233 22.993 4.17753 22.5667 3.678 22.0153C3.16941 21.4739 2.77593 20.8188 2.525 20.0957C2.277 19.4056 2.11 18.6191 2.06 17.4653C2.013 16.3105 2 15.9433 2 12.9998C2 10.0564 2.01 9.68917 2.06 8.53434C2.11 7.3795 2.277 6.59517 2.525 5.904C2.77524 5.18053 3.1688 4.52527 3.678 3.98434C4.17767 3.43317 4.78243 3.00688 5.45 2.73525C6.088 2.46659 6.812 2.28567 7.878 2.2315C8.944 2.18059 9.283 2.1665 12 2.1665ZM12 7.58317C10.6739 7.58317 9.40215 8.15385 8.46447 9.16967C7.52678 10.1855 7 11.5632 7 12.9998C7 14.4364 7.52678 15.8142 8.46447 16.83C9.40215 17.8458 10.6739 18.4165 12 18.4165C13.3261 18.4165 14.5979 17.8458 15.5355 16.83C16.4732 15.8142 17 14.4364 17 12.9998C17 11.5632 16.4732 10.1855 15.5355 9.16967C14.5979 8.15385 13.3261 7.58317 12 7.58317ZM18.5 7.31234C18.5 6.95319 18.3683 6.60875 18.1339 6.3548C17.8995 6.10084 17.5815 5.95817 17.25 5.95817C16.9185 5.95817 16.6005 6.10084 16.3661 6.3548C16.1317 6.60875 16 6.95319 16 7.31234C16 7.67148 16.1317 8.01592 16.3661 8.26988C16.6005 8.52383 16.9185 8.6665 17.25 8.6665C17.5815 8.6665 17.8995 8.52383 18.1339 8.26988C18.3683 8.01592 18.5 7.67148 18.5 7.31234ZM12 9.74984C12.7956 9.74984 13.5587 10.0922 14.1213 10.7017C14.6839 11.3112 15 12.1379 15 12.9998C15 13.8618 14.6839 14.6884 14.1213 15.2979C13.5587 15.9074 12.7956 16.2498 12 16.2498C11.2044 16.2498 10.4413 15.9074 9.87868 15.2979C9.31607 14.6884 9 13.8618 9 12.9998C9 12.1379 9.31607 11.3112 9.87868 10.7017C10.4413 10.0922 11.2044 9.74984 12 9.74984Z"
                    fill="#EC1A1A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_198">
                    <rect width="24" height="26" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </li>
          </a>
          <a href="https://www.instagram.com/techqilla_/">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="23"
                viewBox="0 0 24 23"
                fill="none"
              >
                <g clip-path="url(#clip0_650_201)">
                  <path
                    d="M7.15072 4.79165C7.15046 5.29998 6.94828 5.78739 6.58866 6.14666C6.22904 6.50592 5.74142 6.70761 5.23309 6.70736C4.72476 6.7071 4.23735 6.50493 3.87808 6.1453C3.51882 5.78568 3.31713 5.29806 3.31738 4.78973C3.31764 4.2814 3.51981 3.79399 3.87944 3.43472C4.23906 3.07546 4.72668 2.87377 5.23501 2.87402C5.74334 2.87428 6.23075 3.07646 6.59002 3.43608C6.94928 3.7957 7.15097 4.28332 7.15072 4.79165ZM7.20822 8.12665H3.37488V20.125H7.20822V8.12665ZM13.2649 8.12665H9.45072V20.125H13.2265V13.8287C13.2265 10.3212 17.7978 9.9954 17.7978 13.8287V20.125H21.5832V12.5254C21.5832 6.61248 14.8174 6.8329 13.2265 9.73665L13.2649 8.12665Z"
                    fill="#EC1A1A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_201">
                    <rect
                      width="23"
                      height="23"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </li>
          </a>
        </ul>
      </div>
    </>
  );
}